import { render, staticRenderFns } from "./DashInventoryWatchedCases.vue?vue&type=template&id=7f2e56d2&scoped=true&"
import script from "./DashInventoryWatchedCases.vue?vue&type=script&lang=js&"
export * from "./DashInventoryWatchedCases.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryWatchedCases.vue?vue&type=style&index=0&id=7f2e56d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e56d2",
  null
  
)

export default component.exports